// SearchInput组件翻译
export default {
  // 标签页标题
  tabs: {
    canvasAnalysis: "画布分析",
    dataDetail: "数据详情",
    aiAssessment: "AI研判",
  },

  // 占位符文本
  placeholders: {
    multiCurrency: "搜索地址 / 哈希 / 调证用户ID",
    singleCurrency: "搜索地址 / 哈希",
  },

  // 画布类型选项
  canvasTypes: {
    multi: "多币种画布",
    single: "单币种画布",
  },

  // 按钮和操作
  actions: {
    search: "搜索",
    clear: "清除",
    exampleData: "示例数据",
  },

  // 提示信息
  messages: {
    noAddress: "没有查出该地址",
    singleCurrencyUserNotSupported: "单币种画布暂不支持调证用户查询",
    userFunctionRestricted: "当前功能仅专业版用户可用，请联系客服咨询。",
  },

  // 历史记录
  history: {
    loading: "加载中...",
    noHistory: "暂无历史记录",
  },
};
